import { API, graphqlOperation } from "aws-amplify";
export class PreAssessment {
    constructor() {
    }

    static async sendPreAssessmentEmail({ firstName, preAssessmentLink, email }) {
        const bodyText = `Hi ` + firstName + `,<br/><br/>

Thank you for booking your health assessment appointment with Healthy Performance. Please find below the Pre Assessment Questionnaire link to complete at least 24 hours before your assessment. This should take 3-5 minutes to complete and is really important to ensure we can maximise your time with us.<br/><br/>
    
https://preassessment.healthyevents.co.uk/` + preAssessmentLink + `<br/><br/>
    
Upon completion, you will have access to a short 90 second video of what to expect in your appointment and also the informed consent form that details key things to remember.<br/><br/>
    
If you have any other questions about your assessment please contact team@healthyperformance.co.uk who will be more than happy to help.<br/><br/>
    
Healthy regards<br/>
    
HP Team<br/>
T: 0800 170 1777<br/>
E: team@healthyperformance.co.uk`

        const body = {
            toAddresses: [email],
            body: bodyText,
            subject: "Pre-assessment Reminder Link",
            source: "team@healthyperformance.co.uk"
        }

        const result = await API.post(
            "hpLambdaNotifyUserOfEventApi",
            "/events/sendPreAssessmentEmail",
            {
                body
            }
        );
        return result;
    }
}